<form class="obg-m-iaui-verification-body" [formGroup]="form" (submit)="onDone()">
	<p obgSensitiveData>
		{{ "customer-verification.modal.info" | translate: { firstName: customerFirstName$ | async } }}
	</p>

	<label id="iaui-verification-bank-selection-label">{{
		"customer-verification.modal.bank-selection" | translate
	}}</label>
	<mat-radio-group
		aria-labelledby="iaui-verification-bank-selection-label"
		class="bank-selection-group"
		formControlName="paymentType"
	>
		<mat-radio-button class="bank-option" [value]="iauiPaymentType.swedbank">
			<img obgImageContent="general.bank-icon-swedbank" />
		</mat-radio-button>
		<mat-divider></mat-divider>
		<mat-radio-button class="bank-option" [value]="iauiPaymentType.seb">
			<img obgImageContent="general.bank-icon-seb" />
		</mat-radio-button>
		<mat-divider></mat-divider>
		<mat-radio-button class="bank-option" [value]="iauiPaymentType.citadele">
			<img obgImageContent="general.bank-icon-citadele" />
		</mat-radio-button>
		<mat-divider></mat-divider>
		<mat-radio-button class="bank-option" [value]="iauiPaymentType.revolut">
			<img obgImageContent="general.bank-icon-revolut" />
		</mat-radio-button>
		<mat-divider></mat-divider>
		<mat-radio-button class="bank-option" [value]="iauiPaymentType.luminor">
			<img obgImageContent="general.bank-icon-luminor" />
		</mat-radio-button>
		<mat-divider></mat-divider>
		<mat-radio-button class="bank-option" [value]="iauiPaymentType.trustly">
			<img obgImageContent="general.bank-icon-trustly" />
		</mat-radio-button>
	</mat-radio-group>

	<button
		class="mat-button-base mat-flat-button mat-accent"
		color="accent"
		[disabled]="form.controls.paymentType.invalid"
		mat-flat-button
	>
		{{ "customer-verification.modal.verify" | translate }}
	</button>
</form>
